import {combineReducers} from 'redux'
import {loadingBlurStatus} from './loadingBlurStatus'
import {userAccessInformations} from './userAccessInformations'

export const Reducers = combineReducers({
	//System reducers
	userAccessInformations: userAccessInformations,
	loadingBlurState: loadingBlurStatus,
})
